module.exports = __webpack_public_path__ + "img/success.290e5df6.svg";